import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import {
  MediaCategoryTypeNameEnum,
  MediaTypeNameEnum,
  PageViewModel,
} from "src/domain/client";
import { MediaPipe } from "src/pipes/media.pipe";
import { BrandService } from "src/services/brand.service";
import { ErrorReporterService } from "src/services/error-reporter.service";
import { MapService } from "src/services/map.service";
import { ModelAndDealerService } from "src/services/model-and-dealer.service";
import { OrderService } from "src/services/order.service";
import { PageService } from "src/services/page.service";

interface RouteParams {
  shoppingCartId?: string;
}

@Component({
  selector: "vw-thank-you-page",
  templateUrl: "./thank-you-page.component.html",
})
export class ThankYouPageComponent implements OnInit, OnDestroy {
  page?: PageViewModel;
  loading = false;
  orderId?: number;

  title?: string;
  body?: string;

  private routeSubscription?: Subscription;

  constructor(
    public mapService: MapService,
    public modelAndDealerService: ModelAndDealerService,
    private route: ActivatedRoute,
    private pageService: PageService,
    private errorReporter: ErrorReporterService,
    private orderService: OrderService,
    private brandService: BrandService,
    private mediaPipe: MediaPipe,
  ) {}

  ngOnInit(): void {
    this.getThankYouPage();

    this.routeSubscription = this.route.params.subscribe(
      (params: RouteParams) => {
        if (params.shoppingCartId) {
          this.getOrderId(params.shoppingCartId);
        }
      },
    );
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
  }

  //////////

  private getThankYouPage(): void {
    this.loading = true;
    this.pageService
      .getThankYouPage(this.brandService.brandId)
      .then((page) => {
        this.page = page;
        this.setMedia();
      })
      .catch(this.errorReporter.handle)
      .finally(() => {
        this.loading = false;
      });
  }

  private getOrderId(shoppingCartId: string): void {
    this.orderService
      .getOrderId(shoppingCartId)
      .then((orderId: number) => {
        this.orderId = orderId;
      })
      .catch(this.errorReporter.handle);
  }

  private setMedia(): void {
    this.title = this.mediaPipe.transform(
      this.page?.media,
      MediaCategoryTypeNameEnum.Title,
      MediaTypeNameEnum.Text,
    );

    this.body = this.mediaPipe.transform(
      this.page?.media,
      MediaCategoryTypeNameEnum.Body,
      MediaTypeNameEnum.HTML,
    );
  }
}
